var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 23H0V24H24V23Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.997 21C3.0625 21 3.1295 20.9935 3.197 20.98L6.7035 20.0595C6.897 20.021 7.075 19.9255 7.2145 19.786L22.707 4.293C23.0975 3.9025 23.0975 3.2695 22.707 2.879L20.121 0.293C19.926 0.0975 19.67 0 19.414 0C19.158 0 18.902 0.0975 18.707 0.293L3.214 15.786C3.0745 15.9255 2.979 16.1035 2.9405 16.297L2.02 19.8035C1.8935 20.4355 2.385 21 2.997 21ZM3.9155 16.5225L3.9215 16.4935L19.4135 1H19.4145L22 3.586L6.507 19.079L6.478 19.085L3.0035 19.9975L3.9155 16.5225Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.22b91e47aa36c9510214fa288f4c8686.svg";
export { ForwardRef as ReactComponent };